import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule, Routes} from '@angular/router';
import {ComponentsModule} from '../../components/components.module';
import {ContactsComponent} from "./contacts.component";
import {ContactEditComponent} from './contact-edit/contact-edit.component';
import {ReactiveFormsModule} from "@angular/forms";
import {FontAwesomeModule} from "@fortawesome/angular-fontawesome";
import {NgbDropdownModule} from "@ng-bootstrap/ng-bootstrap";
import {NgxMatomoTrackerModule} from 'ngx-matomo-client';

const secondaryRoutes: Routes = [
  {
    path: '',
    component: ContactsComponent
  },
  {
    path: 'creer',
    component: ContactEditComponent,
  },
  {
    path: 'modifier/:id',
    component: ContactEditComponent,
  }
];

@NgModule({
  declarations: [
    ContactsComponent,
    ContactEditComponent
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(secondaryRoutes),
    ComponentsModule,
    ReactiveFormsModule,
    FontAwesomeModule,
    NgbDropdownModule,
    NgxMatomoTrackerModule,
  ]
})
export class ContactsModule {
}
